export default "__VITE_ASSET__5170b7f4__"